import { Observable } from "rxjs/Observable";
import { UserProfile } from "../../models/user-profile";
import * as _ from "underscore"

export class SharedProfileService {
    userProfile: UserProfile | null;

    constructor() {
    }

    setData(data: UserProfile | null) {
        this.userProfile = data;
    }

    public getData(): UserProfile {
        return this.userProfile || new UserProfile();    
    }

    public isDelegatedAssignedOpStatement(): boolean {
        try {
            if (this.userProfile && this.userProfile.userTypeAssignments) {
                let opStatements = _.find(this.userProfile.userTypeAssignments, function (assign) { return assign.isAllowedOperationalStatement==true; });
                return !!opStatements;
            }
        }
        catch (err) {

        }

        return false;
    }

    public isDelegatedAssignedFinStatement(): boolean {
        try {
            if (this.userProfile && this.userProfile.userTypeAssignments) {
                let finStatements = _.find(this.userProfile.userTypeAssignments, function (assign) { return assign.isAllowedFinancialStatement==true; });
                return !!finStatements;
            }
        }
        catch (err) {

        }

        return false;
    }
}